// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation" ng-if="\$ctrl.deposit">

  <sub-header header="'Partial withdrawal with cash'"></sub-header>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.deposit.productDefinition.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Product number:</span>
        <span class="value">{{\$ctrl.deposit.productNumber}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.deposit.balance | nxCurrency}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Minimum balance:</span>
        <span class="value">{{\$ctrl.deposit.depositType.minimalBalance | nxCurrency}}</span>
      </div>
      <div class="override">
        <span class="key">Override withdraw amount:</span>
        <span class="value"><input type="checkbox" ng-model="\$ctrl.overrideCheckbox" ng-change="\$ctrl.setDefaultWithdrawalAmount(); \$ctrl.requireSimulation(); \$ctrl.setOverrideMaxWithdrawalAmount()"/></span>
      </div>
    </div>

    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <tr ng-if="\$ctrl.overrideCheckbox">
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Default
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Overridden
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Gross interest:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.interest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-disabled="true" ng-model="\$ctrl.override.grossInterest">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.withholdingTax"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.withholdingTax"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"
                  ng-required="true"
                  min="0"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Net interest:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.netInterest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.netInterest"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"
                  ng-required="true"
                  min="0"></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.interestForecast.terminationFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Max withdrawal amount:</td>
          <td>
            <cash ng-model="\$ctrl.maxWithdrawalAmount"
                  ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.maxWithdrawalAmount"
                  ng-disabled="true"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withdraw amount:</td>
          <td>
            <cash ng-model="\$ctrl.request.amount"
                  ng-disabled="\$ctrl.overrideCheckbox"
                  ng-required="true"
                  max="\$ctrl.maxWithdrawalAmount"
                  ng-change="\$ctrl.requireSimulation()"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.amount"
                  max="\$ctrl.override.maxWithdrawalAmount"
                  ng-required="true"
                  ng-change="\$ctrl.requireSimulation()"></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.beforeRolloverFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()" ></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.afterRolloverFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()">
            </cash>
          </td>
        </tr>
        <tr ng-if="\$ctrl.netRolloverAmount || \$ctrl.override.netRolloverAmount">
          <td></td>
          <td>Rollover amount:</td>
          <td>
            <cash ng-model="\$ctrl.netRolloverAmount"
                  ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.netRolloverAmount"
                  ng-disabled="true"></cash>
          </td>
        </tr>
        </tbody>
      </table>

      <div ng-if="\$ctrl.simulationErrors.length > 0">
        <dynamic-list
          generate-row-ids="false"
          columns="\$ctrl.formatErrorColumns"
          data="\$ctrl.simulationErrors"
          list-type="'ERROR'">
        </dynamic-list>
      </div>

      <div class="buttons">
        <signature-card
          file-id="\$ctrl.deposit.signatureCardFileId"
          product-group="'DEPOSIT'"
          product-status="\$ctrl.deposit.status"></signature-card>
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.simulatePartialWithdrawal()"
          ng-disabled="\$ctrl.isSimulatePartialWithdrawalDisabled()">
          Simulate
        </button>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.partialWithdrawal()"
          ng-disabled="\$ctrl.isPartialWithdrawalDisabled()">
          Withdraw
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/partial-withdrawal-cash/partial-withdrawal-cash.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;